import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function getPublicPlace(condition = {placeType: ''}) {
    let response = {}
    let placeType = Utils.isEmptyObject(condition.placeType)? '' : condition.placeType
    let placeTypeQuery = Utils.isEmptyString(placeType)? '' : `/publicType/${placeType}`
    try {
        response = await axios.get(`${config.eastCoastDataApi()}BaseData/PublicPlace${placeTypeQuery}`)

    } catch (err) {
        console.error('iisi getPublicPlace: ', err)
        return null
    }

    return {publicPlaceData: response.data, placeType: placeType}
}

export async function getDeviceByPublicPlaceId(condition = {id: -1}) {
    let response = {}
    let id = Utils.isEmptyObject(condition.id)? -1 : condition.id
    if(id < 1) {
        console.error('iisi getDeviceByPublicPlaceId: id error')
        return
    }
    let idQuery = `/${id}`
    try {
        response = await axios.get(`${config.eastCoastDataApi()}BaseData/PublicPlace${idQuery}/Devices`)

    } catch (err) {
        console.error('iisi getDeviceByPublicPlaceId: ', err)
        return null
    }

    return response.data
}

export async function postPublicPlace(publicPlace = {}) {
    let response = {}
    if (Utils.isEmptyObject(publicPlace)) {
        console.error('iisi postPublicPlace: publicPlace is null')
        Utils.setApiResponsSuccess(response)
        return response
    }

    try {

        response = await axios.post(`${config.eastCoastDataApi()}BaseData/PublicPlace`, publicPlace)

    } catch (err) {
        console.error('iisi PublicPlace: ', err)
        return null
    }

    Utils.setApiResponsSuccess(response)
    return response
}

export async function putPublicPlace(publicPlace = {}) {
    let response = {}
    if (Utils.isEmptyObject(publicPlace) || Utils.isEmptyObject(publicPlace.id)) {
        console.error('iisi publicPlace: publicPlace is null')
        Utils.setApiResponsSuccess(response)
        return response
    }

    try {
        response = await axios.put(`${config.eastCoastDataApi()}BaseData/PublicPlace/${publicPlace.id}`, publicPlace)
        
    } catch (err) {
        console.error('iisi putPublicPlace: ', err)
        Utils.setApiResponsSuccess(response)
        return response
    }

    Utils.setApiResponsSuccess(response)
    return response
}

export async function deletePublicPlace(publicPlaceId = '') {
    let response = {}
    if (Utils.isEmptyString(publicPlaceId)) {
        console.error('iisi deletePublicPlace: publicPlaceId is empty')
        Utils.setApiResponsSuccess(response)
        return response
    }

    try {
        response = await axios.delete(`${config.eastCoastDataApi()}BaseData/PublicPlace/${publicPlaceId}`)

    } catch (err) {

        if(err.response && err.response.status === 409){
            return err.response;
        }else{
            console.error('iisi deleteDevice: ', err)
            return null

        }
    }

    Utils.setApiResponsSuccess(response)
    return response
}